import React, { useRef } from "react";

const Emojis = ({ handleAddEmoji }) => {
  const smile_1 = useRef();
  const smile_2 = useRef();
  const smile_3 = useRef();
  const smile_4 = useRef();
  const smile_5 = useRef();
  const smile_6 = useRef();
  const smile_7 = useRef();
  const smile_8 = useRef();
  const smile_9 = useRef();
  const smile_10 = useRef();
  const smile_11 = useRef();
  const smile_12 = useRef();
  const smile_13 = useRef();
  const smile_14 = useRef();
  const smile_15 = useRef();
  const smile_16 = useRef();
  const smile_17 = useRef();
  const smile_18 = useRef();
  const smile_19 = useRef();
  const smile_20 = useRef();

  const smileys = [
    <button
      key="smile_1"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_1.current.innerText)}
    >
      <span ref={smile_1} role="img" aria-label="smile_1">
        😃
      </span>
    </button>,
    <button
      key="smile_2"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_2.current.innerText)}
    >
      <span ref={smile_2} role="img" aria-label="smiley_2">
        😄
      </span>
    </button>,
    <button
      key="smile_3"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_3.current.innerText)}
    >
      <span ref={smile_3} role="img" aria-label="smiley">
        😁
      </span>
    </button>,
    <button
      key="smile_4"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_4.current.innerText)}
    >
      <span ref={smile_4} role="img" aria-label="smiley">
        😆
      </span>
    </button>,
    <button
      key="smile_5"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_5.current.innerText)}
    >
      <span ref={smile_5} role="img" aria-label="smiley">
        😅
      </span>
    </button>,
    <button
      key="smile_6"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_6.current.innerText)}
    >
      <span ref={smile_6} role="img" aria-label="smiley">
        😂
      </span>
    </button>,
    <button
      key="smile_7"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_7.current.innerText)}
    >
      <span ref={smile_7} role="img" aria-label="smiley">
        🤣
      </span>
    </button>,
    <button
      key="smile_8"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_8.current.innerText)}
    >
      <span ref={smile_8} role="img" aria-label="smiley">
        🥲
      </span>
    </button>,
    <button
      key="smile_9"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_9.current.innerText)}
    >
      <span ref={smile_9} role="img" aria-label="smiley">
        😊
      </span>
    </button>,
    <button
      key="smile_10"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_10.current.innerText)}
    >
      <span ref={smile_10} role="img" aria-label="smiley">
        😇
      </span>
    </button>,
    <button
      key="smile_11"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_11.current.innerText)}
    >
      <span ref={smile_11} role="img" aria-label="smiley">
        🙂
      </span>
    </button>,
    <button
      key="smile_12"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_12.current.innerText)}
    >
      <span ref={smile_12} role="img" aria-label="smiley">
        🙃
      </span>
    </button>,
    <button
      key="smile_13"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_13.current.innerText)}
    >
      <span ref={smile_13} role="img" aria-label="smiley">
        😉
      </span>
    </button>,
    <button
      key="smile_14"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_14.current.innerText)}
    >
      <span ref={smile_14} role="img" aria-label="smiley">
        😌
      </span>
    </button>,
    <button
      key="smile_15"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_15.current.innerText)}
    >
      <span ref={smile_15} role="img" aria-label="smiley">
        😍
      </span>
    </button>,
    <button
      key="smile_16"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_16.current.innerText)}
    >
      <span ref={smile_16} role="img" aria-label="smiley">
        🥰
      </span>
    </button>,
    <button
      key="smile_17"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_17.current.innerText)}
    >
      <span ref={smile_17} role="img" aria-label="smiley">
        😘
      </span>
    </button>,
    <button
      key="smile_18"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_18.current.innerText)}
    >
      <span ref={smile_18} role="img" aria-label="smiley">
        😗
      </span>
    </button>,
    <button
      key="smile_19"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_19.current.innerText)}
    >
      <span ref={smile_19} role="img" aria-label="smiley">
        😙
      </span>
    </button>,
    <button
      key="smile_20"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(smile_20.current.innerText)}
    >
      <span ref={smile_20} role="img" aria-label="smiley">
        😚
      </span>
    </button>
  ];

  const gesture_1 = useRef();
  const gesture_2 = useRef();
  const gesture_3 = useRef();
  const gesture_4 = useRef();
  const gesture_5 = useRef();
  const gesture_6 = useRef();
  const gesture_7 = useRef();
  const gesture_8 = useRef();
  const gesture_9 = useRef();
  const gesture_10 = useRef();
  const gesture_11 = useRef();
  const gesture_12 = useRef();
  const gesture_13 = useRef();
  const gesture_14 = useRef();
  const gesture_15 = useRef();
  const gesture_16 = useRef();
  const gesture_17 = useRef();
  const gesture_18 = useRef();
  const gesture_19 = useRef();
  const gesture_20 = useRef();

  const gestures = [
    <button
      key="gesture_1"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_1.current.innerText)}
    >
      <span ref={gesture_1} role="img" aria-label="gesture">
        👋
      </span>
    </button>,
    <button
      key="gesture_2"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_2.current.innerText)}
    >
      <span ref={gesture_2} role="img" aria-label="gesture">
        🤚
      </span>
    </button>,
    <button
      key="gesture_3"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_3.current.innerText)}
    >
      <span ref={gesture_3} role="img" aria-label="gesture">
        🖐
      </span>
    </button>,
    <button
      key="gesture_4"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_4.current.innerText)}
    >
      <span ref={gesture_4} role="img" aria-label="gesture">
        ✋
      </span>
    </button>,
    <button
      key="gesture_5"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_5.current.innerText)}
    >
      <span ref={gesture_5} role="img" aria-label="gesture">
        🖖
      </span>
    </button>,
    <button
      key="gesture_6"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_6.current.innerText)}
    >
      <span ref={gesture_6} role="img" aria-label="gesture">
        👌
      </span>
    </button>,
    <button
      key="gesture_7"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_7.current.innerText)}
    >
      <span ref={gesture_7} role="img" aria-label="gesture">
        🤌
      </span>
    </button>,
    <button
      key="gesture_8"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_8.current.innerText)}
    >
      <span ref={gesture_8} role="img" aria-label="gesture">
        🤏
      </span>
    </button>,
    <button
      key="gesture_9"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_9.current.innerText)}
    >
      <span ref={gesture_9} role="img" aria-label="gesture">
        🤞
      </span>
    </button>,
    <button
      key="gesture_10"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_10.current.innerText)}
    >
      <span ref={gesture_10} role="img" aria-label="gesture">
        🤟
      </span>
    </button>,
    <button
      key="gesture_11"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_11.current.innerText)}
    >
      <span ref={gesture_11} role="img" aria-label="gesture">
        🤘
      </span>
    </button>,
    <button
      key="gesture_12"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_12.current.innerText)}
    >
      <span ref={gesture_12} role="img" aria-label="gesture">
        🤙
      </span>
    </button>,
    <button
      key="gesture_13"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_13.current.innerText)}
    >
      <span ref={gesture_13} role="img" aria-label="gesture">
        👈
      </span>
    </button>,
    <button
      key="gesture_14"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_14.current.innerText)}
    >
      <span ref={gesture_14} role="img" aria-label="gesture">
        👉
      </span>
    </button>,
    <button
      key="gesture_15"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_15.current.innerText)}
    >
      <span ref={gesture_15} role="img" aria-label="gesture">
        👆
      </span>
    </button>,
    <button
      key="gesture_16"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_16.current.innerText)}
    >
      <span ref={gesture_16} role="img" aria-label="gesture">
        🖕
      </span>
    </button>,
    <button
      key="gesture_17"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_17.current.innerText)}
    >
      <span ref={gesture_17} role="img" aria-label="gesture">
        👇
      </span>
    </button>,
    <button
      key="gesture_18"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_18.current.innerText)}
    >
      <span ref={gesture_18} role="img" aria-label="gesture">
        👍
      </span>
    </button>,
    <button
      key="gesture_19"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_19.current.innerText)}
    >
      <span ref={gesture_19} role="img" aria-label="gesture">
        🙏
      </span>
    </button>,
    <button
      key="gesture_20"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(gesture_20.current.innerText)}
    >
      <span ref={gesture_20} role="img" aria-label="gesture">
        👎
      </span>
    </button>
  ];

  const food_1 = useRef();
  const food_2 = useRef();
  const food_3 = useRef();
  const food_4 = useRef();
  const food_5 = useRef();
  const food_6 = useRef();
  const food_7 = useRef();
  const food_8 = useRef();
  const food_9 = useRef();
  const food_10 = useRef();
  const food_11 = useRef();
  const food_12 = useRef();
  const food_13 = useRef();
  const food_14 = useRef();
  const food_15 = useRef();
  const food_16 = useRef();
  const food_17 = useRef();
  const food_18 = useRef();
  const food_19 = useRef();
  const food_20 = useRef();

  const food_drink = [
    <button
      key="food_1"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_1.current.innerText)}
    >
      <span ref={food_1} role="img" aria-label="food">
        🍎
      </span>
    </button>,
    <button
      key="food_2"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_2.current.innerText)}
    >
      <span ref={food_2} role="img" aria-label="food">
        🍐
      </span>
    </button>,
    <button
      key="food_3"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_3.current.innerText)}
    >
      <span ref={food_3} role="img" aria-label="food">
        🍊
      </span>
    </button>,
    <button
      key="food_4"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_4.current.innerText)}
    >
      <span ref={food_4} role="img" aria-label="food">
        🥑
      </span>
    </button>,
    <button
      key="food_5"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_5.current.innerText)}
    >
      <span ref={food_5} role="img" aria-label="food">
        🍆
      </span>
    </button>,
    <button
      key="food_6"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_6.current.innerText)}
    >
      <span ref={food_6} role="img" aria-label="food">
        🥡
      </span>
    </button>,
    <button
      key="food_7"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_7.current.innerText)}
    >
      <span ref={food_7} role="img" aria-label="food">
        🍩
      </span>
    </button>,
    <button
      key="food_8"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_8.current.innerText)}
    >
      <span ref={food_8} role="img" aria-label="food">
        🍪
      </span>
    </button>,
    <button
      key="food_9"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_9.current.innerText)}
    >
      <span ref={food_9} role="img" aria-label="food">
        🌮
      </span>
    </button>,
    <button
      key="food_10"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_10.current.innerText)}
    >
      <span ref={food_10} role="img" aria-label="food">
        🌯
      </span>
    </button>,
    <button
      key="food_11"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_11.current.innerText)}
    >
      <span ref={food_11} role="img" aria-label="food">
        🍜
      </span>
    </button>,
    <button
      key="food_12"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_12.current.innerText)}
    >
      <span ref={food_12} role="img" aria-label="food">
        🌭
      </span>
    </button>,
    <button
      key="food_13"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_13.current.innerText)}
    >
      <span ref={food_13} role="img" aria-label="food">
        🍔
      </span>
    </button>,
    <button
      key="food_14"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_14.current.innerText)}
    >
      <span ref={food_14} role="img" aria-label="food">
        🍕
      </span>
    </button>,
    <button
      key="food_15"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_15.current.innerText)}
    >
      <span ref={food_15} role="img" aria-label="food">
        🥞
      </span>
    </button>,
    <button
      key="food_16"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_16.current.innerText)}
    >
      <span ref={food_16} role="img" aria-label="food">
        🍾
      </span>
    </button>,
    <button
      key="food_17"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_17.current.innerText)}
    >
      <span ref={food_17} role="img" aria-label="food">
        🍷
      </span>
    </button>,
    <button
      key="food_18"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_18.current.innerText)}
    >
      <span ref={food_18} role="img" aria-label="food">
        🥂
      </span>
    </button>,
    <button
      key="food_19"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_19.current.innerText)}
    >
      <span ref={food_19} role="img" aria-label="food">
        🍿
      </span>
    </button>,
    <button
      key="food_20"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(food_20.current.innerText)}
    >
      <span ref={food_20} role="img" aria-label="food">
        🍻
      </span>
    </button>
  ];

  const misc_1 = useRef();
  const misc_2 = useRef();
  const misc_3 = useRef();
  const misc_4 = useRef();
  const misc_5 = useRef();
  const misc_6 = useRef();
  const misc_7 = useRef();
  const misc_8 = useRef();
  const misc_9 = useRef();
  const misc_10 = useRef();
  const misc_11 = useRef();
  const misc_12 = useRef();
  const misc_13 = useRef();
  const misc_14 = useRef();
  const misc_15 = useRef();
  const misc_16 = useRef();
  const misc_17 = useRef();
  const misc_18 = useRef();
  const misc_19 = useRef();
  const misc_20 = useRef();

  const misc = [
    <button
      key="misc_1"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_1.current.innerText)}
    >
      <span ref={misc_1} role="img" aria-label="misc-emoji">
        🚨
      </span>
    </button>,
    <button
      key="misc_2"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_2.current.innerText)}
    >
      <span ref={misc_2} role="img" aria-label="misc-emoji">
        ⛽️
      </span>
    </button>,
    <button
      key="misc_3"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_3.current.innerText)}
    >
      <span ref={misc_3} role="img" aria-label="misc-emoji">
        🚀
      </span>
    </button>,
    <button
      key="misc_4"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_4.current.innerText)}
    >
      <span ref={misc_4} role="img" aria-label="misc-emoji">
        🛫
      </span>
    </button>,
    <button
      key="misc_5"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_5.current.innerText)}
    >
      <span ref={misc_5} role="img" aria-label="misc-emoji">
        🏆
      </span>
    </button>,
    <button
      key="misc_6"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_6.current.innerText)}
    >
      <span ref={misc_6} role="img" aria-label="misc-emoji">
        🌞
      </span>
    </button>,
    <button
      key="misc_7"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_7.current.innerText)}
    >
      <span ref={misc_7} role="img" aria-label="misc-emoji">
        🍀
      </span>
    </button>,
    <button
      key="misc_8"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_8.current.innerText)}
    >
      <span ref={misc_8} role="img" aria-label="misc-emoji">
        🌝
      </span>
    </button>,
    <button
      key="misc_9"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_9.current.innerText)}
    >
      <span ref={misc_9} role="img" aria-label="misc-emoji">
        🌎
      </span>
    </button>,
    <button
      key="misc_10"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_10.current.innerText)}
    >
      <span ref={misc_10} role="img" aria-label="misc-emoji">
        🔥
      </span>
    </button>,
    <button
      key="misc_11"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_11.current.innerText)}
    >
      <span ref={misc_11} role="img" aria-label="misc-emoji">
        🌈
      </span>
    </button>,
    <button
      key="misc_12"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_12.current.innerText)}
    >
      <span ref={misc_12} role="img" aria-label="misc-emoji">
        💰
      </span>
    </button>,
    <button
      key="misc_13"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_13.current.innerText)}
    >
      <span ref={misc_13} role="img" aria-label="misc-emoji">
        ⏰
      </span>
    </button>,
    <button
      key="misc_14"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_14.current.innerText)}
    >
      <span ref={misc_14} role="img" aria-label="misc-emoji">
        ⏳
      </span>
    </button>,
    <button
      key="misc_15"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_15.current.innerText)}
    >
      <span ref={misc_15} role="img" aria-label="misc-emoji">
        📱
      </span>
    </button>,
    <button
      key="misc_16"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_16.current.innerText)}
    >
      <span ref={misc_16} role="img" aria-label="misc-emoji">
        📸
      </span>
    </button>,
    <button
      key="misc_17"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_17.current.innerText)}
    >
      <span ref={misc_17} role="img" aria-label="misc-emoji">
        📫
      </span>
    </button>,
    <button
      key="misc_18"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_18.current.innerText)}
    >
      <span ref={misc_18} role="img" aria-label="misc-emoji">
        👕
      </span>
    </button>,
    <button
      key="misc_19"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_19.current.innerText)}
    >
      <span ref={misc_19} role="img" aria-label="misc-emoji">
        🎉
      </span>
    </button>,
    <button
      key="misc_20"
      type="button"
      className="focus:outline-none focus:border-none active:outline-none active:border-none"
      onClick={() => handleAddEmoji(misc_20.current.innerText)}
    >
      <span ref={misc_20} role="img" aria-label="misc-emoji">
        🎊
      </span>
    </button>
  ];
  return (
    <>
      <div className="flex flex-col bg-gray-300 rounded-md px-2 pb-2 pt-1 shadow-md w-52 overflow-auto h-48">
        <small className="text-gray-600 py-1 font-semibold mb-2">Emojis</small>
        <small className="text-gray-600 py-1">smileys:</small>
        <div className="bg-gray-400 px-1 rounded-md py-1">{smileys}</div>
        <small className="text-gray-600 py-1">gestures:</small>
        <div className="bg-gray-400 px-1 rounded-md py-1">{gestures}</div>
        <small className="text-gray-600 py-1">food and drinks:</small>
        <div className="bg-gray-400 px-1 rounded-md py-1">{food_drink}</div>
        <small className="text-gray-600 py-1">misc:</small>
        <div className="bg-gray-400 px-1 rounded-md py-1">{misc}</div>
      </div>
    </>
  );
};

export default Emojis;
